goog.provide("shadow.js.shim.module$react_native_paper");
goog.provide("module$shadow_js_shim_module$react_native_paper");
shadow.js.shim.module$react_native_paper = require("react-native-paper");
module$shadow_js_shim_module$react_native_paper.default = shadow.js.shim.module$react_native_paper;
